<template>
  <div class="container sinottico-container">
    <div class="row synoptic-search-row">
      <div class="col-lg-4">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text synoptic-search-icon"><i class="fa fa-search"></i></span>
          </div>
          <input v-model="search" id="search-element" key="search-element" class="synoptic-search-input form-control" type="text" maxlength="200" placeholder="Cerca...">
        </div>

      </div>
    </div>
    <div v-if="page == 'dashboard' && selectedSiteFull != undefined && selectedSiteFull.siteName != undefined" class="row">
      <div class="col-md-2">
        <div class="dipartimento">
          <span v-html="'Sito ' + selectedSiteFull.siteName" :class="{'cursor-pointer': siteDashboard}" @click="select('site', siteDashboard)"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-for="(department, departmentId) in tree.departments" :key="departmentId" :class="hideElements[departmentId] == undefined || !hideElements[departmentId]['hide'] ? 'col-md-2.4 sinottico': 'col-md-2.4 sinottico hide'">
        <div>
          <div class="dipartimento">
            <span v-html="department.name" :class="{'cursor-pointer': department[fireElement], 'selected-item': selectedItem['department___' + departmentId] != undefined}" @click="select('department', department[fireElement], departmentId, department.name)"></span>
          </div>

          <template v-for="(machine, machineId) in department.machines">
            <a :class="(machine[fireElement] ? 'cursor-pointer item macchina': 'item macchina cursor-default') + (selectedItem['machine___' + machineId] != undefined ? ' selected-item': '')" href="#" :key="machineId" @click.prevent="select('machine', machine[fireElement], departmentId, department.name, machineId, machine.name)">
              <span v-html="machine.name"></span>
            </a>
            <a v-for="(device, deviceId) in machine.devices" :class="(device[fireElement] || (selectDevices != undefined && selectDevices) ? 'cursor-pointer item dispositivo-dark': 'item dispositivo-dark cursor-default') + (selectedItem['device___' + deviceId] != undefined ? ' selected-item': '')" href="#" :key="deviceId" @click.prevent="select('device', device[fireElement], departmentId, department.name, machineId, machine.name, deviceId, device.name)">
              <span v-html="device.name"></span>
            </a>
            <hr v-if="Object.keys(department.machines)[Object.keys(department.machines).length - 1] != machineId" :key="machineId + '-hr'" />            
          </template>
        </div>
      </div>
    </div>
    <div v-if="page == 'acquisitions' && multiDevice.devices.length > 0" class="select-tool">
      <a href="#" @click="emit(multiDevice);">
        <span class="sr-only">Seleziona</span>
        <span v-if="multiDevice.devices.length == 1">Seleziona dispositivo</span>
        <span v-else>Confronta dispositivi</span>
      </a>
      </div>
    <overlay :enabled="loading"></overlay>
  </div>
</template>

<script>
  import axios from 'axios'
  import sha1 from 'js-sha1';
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'
  import notificator from '@/mixins/notificator';

  import Overlay from '@/components/Overlay.vue';
  
  export default {
    props: ['page', 'selectDevices'],

    components: {Overlay},

    mixins: [notificator],

    data() {
      return {
        tree: {},
        loading: false,
        hideElements: {},
        siteDashboard: false,
        multiDevice: {'multidevice': true, devices: []},
        selectedItem: {},

        search: ''

      }
    },

    mounted() {
      switch (this.page) {
        case 'dashboard': this.getTree('GetDashboardTree'); break;
        case 'acquisitions': this.getTree('GetDashboardTree'); break; // TO DO MODIFICARE con GetClientTree quando pronta
        case 'consumptions': this.getTree('GetConsumptionsTree'); break;
        case 'alarms': this.getTree('GetAlarmsTree'); break;              
      }
    },

    computed: {
      ...mapGetters([
        'token',
        'clientId',
        'clientSites',
        'selectedSite',
        'selectedSiteFull'
      ]),

      fireElement() {
        switch (this.page) {
          case 'dashboard': return 'dashboard';
          case 'acquisitions': return ''; // TO DO MODIFICARE con GetClientTree quando pronta
          case 'consumptions': return 'consumptionPresent';
          case 'alarms': return 'alarmPresent';
          default: return '';              
        }
      }
    },

    watch: {
      search() {
        if(this.search == '')
          return this.hideElements = {};

        this.searchElement();
      }
    },

    methods: {
      ...mapActions([
        'changeMonitorDashboard',
        'changeAcquisitionsDevices',
        'changeConsumptionsDevices',
        'changeAlarmsDevices'
      ]),

      getDigest(request) {
        return sha1(process.env.VUE_APP_DIGEST_SALT + JSON.stringify(request));
      },

      getTree(method) {
        this.overlay(true);

        var request = {
          clientId: this.clientId,
          sessionToken: this.token,
          // cacheInfoDTO: {forceCacheReload: true}
        };

        var config = {};
          
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': this.getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }

        axios.post(axios.defaults.baseURL + '/EmonClientManagement.Service/service/' + method + '/json', request, config)
        .catch(error => {
          this.notify(this.$options.filters.notification({endpoint: method, code: error.response.data.mispErrorDTO.code != undefined ? error.response.data.mispErrorDTO.code : 500}));
          this.overlay(false);
        }).then(({data}) => {
          
          if(data.sites == undefined) {
            this.overlay(false);
            
            //Emetto evento close synoptic
            this.$emit('close-synoptic');

            return this.notify(this.$options.filters.notification({endpoint: method, code: 500}));
          }
          
          if(data.sites[this.selectedSite] != undefined)
            this.$set(this, 'tree', data.sites[this.selectedSite]);

          //Verifico se è presenta la dashboard del sito
          if(data.sites[this.selectedSite].dashboard != undefined && data.sites[this.selectedSite].dashboard)
            this.siteDashboard = true;
          else
            this.siteDashboard = false;
          
          // this.notify(this.$options.filters.notification({endpoint: method, code: 200}));
          
          this.overlay(false);
        });
      },
      
      select(type, isActive, departmentId, departmentName, machineId, machineName, deviceId, deviceName) {
        if(isActive || (this.selectDevices && departmentId != undefined && machineId != undefined && deviceId != undefined)) {
          var selected = {}

          if(departmentId != undefined)
            selected['department'] = {id: departmentId, name: departmentName}
          
          if(machineId != undefined)
            selected['machine'] = {id: machineId, name: machineName}
          
          if(deviceId != undefined)
            selected['device'] = {id: deviceId, name: deviceName}

          //NOTA: DECOMMENTARE QUANDO TERMINATO IL CONFRONTO DISPOSITIVI
          // if(this.page != 'acquisitions')
            return this.emit(selected);   
            
          //Pagina acquisizioni = selezione multipla device;
          //NOTA: Al momento per le acquisizioni si possono selezionare SOLO i device
          // this.multiDevice['devices'].push(selected);

          // this.$set(this.selectedItem, type + '___' + selected[type]['id'], true);          
        }
      },  

      emit(selected) {
        if(selected['multidevice'] != undefined && selected.devices.length == 1)
          selected = selected.devices[0];
          
        //Action salvo in storage il blocco
          var storeMethod = ''; 
          switch (this.page) {
            case 'dashboard': storeMethod = 'changeMonitorDashboard'; break;
            case 'acquisitions': storeMethod = 'changeAcquisitionsDevices'; break; // TO DO MODIFICARE con GetClientTree o similari quando pronta
            case 'consumptions': storeMethod = 'changeConsumptionsDevices'; break;
            case 'alarms': storeMethod = 'changeAlarmsDevices'; break;              
          }
          
          this.$store.dispatch(storeMethod, selected);
          
          //Emetto evento close synoptic
          this.$emit('close-synoptic');
      },

      searchElement() {
        var list = {};
        var lowerSearch = this.search.toLowerCase();

        this.overlay(true);
        
        for (let departmentIndex in this.tree.departments) {
          
          //Dipartimento
          var finded = false;
          
          if(this.tree.departments[departmentIndex]['name'].toLowerCase().indexOf(lowerSearch) !== -1) {
            finded = true;
            continue;
          } else {
            for (let machineIndex in this.tree.departments[departmentIndex]['machines']) {
              //Macchina
              if(this.tree.departments[departmentIndex]['machines'][machineIndex]['name'].toLowerCase().indexOf(lowerSearch) !== -1) {
                finded = true;
                break;
              } else {
                
                for (let deviceIndex in this.tree.departments[departmentIndex]['machines'][machineIndex]['devices']) {
                  //Dispositivo
                  if(this.tree.departments[departmentIndex]['machines'][machineIndex]['devices'][deviceIndex]['name'].toLowerCase().indexOf(lowerSearch) !== -1) {
                    finded = true;
                    break;
                  }              
                }
              }              
            }
          }
          
          if(list[departmentIndex] == undefined)
            list[departmentIndex] = {};

          list[departmentIndex]['hide'] = !finded;        
        }
        
        this.hideElements = list;

        this.overlay(false);
      },
      
      overlay(action) {
        this.loading = action;
      },  
    }
  };
</script>

<style>
.synoptic-search-row {
  margin: 40px 10px 0px 10px !important;
}
.synoptic-search-input {
  height: 45px !important;
  border-radius: 0px 45px 45px 0px !important;
  border-left: 0px !important;
}
.synoptic-search-icon {
  border-radius: 45px 0px 0px 45px !important;
  background-color: white !important;
  border-right: 0px !important;
  color:rgb(73, 80, 87) !important;
  display:flex !important;
  font-size:16px !important;
  font-weight:400 !important;
  margin-bottom: 0px !important;
}
.form-control:focus {
    /* color: red; */
    background-color: #fff;
    border-color: transparent;
}
.selected-item {
  border: 3px solid #595959;
}

.select-tool {
	position: fixed;
	bottom: 30px;
	right: 30px;
  border-radius: 17px;
  padding-right: 10px;
  padding-left: 10px;
  background-color: #838f9e;
  border-color: #535e6b;
	z-index: 2;
}

.select-tool a {
  color: #fff;
  text-decoration: none;
  display: block;
  /* width: 60px; */
  height: 60px;
  line-height: 60px;
  text-align: center;	
}
.select-tool a:hover, 
.select-tool a:focus,
.select-tool a:active {
  color: #13557F;
}
</style>